<template>
  <div class="panel fobpanel">
    <div class="panel-heading">
      <translate>Projektleitung</translate>
    </div>
    <div class="panel-block">
        <ul>
          <li v-for="(leiter, index) in resourceData"
            :key="index"
          >
            <fob-entity-value
              :bit="bit"
              :resourceData="leiter.person"
              :isPublic="false"
              :plain="false"
              :linkProvider="linkProvider"
            ></fob-entity-value>

            <!-- GraphQL doesn't fetch role, that's why there's a guard clause here -->
            <!-- Deactivate 'Rolle' for now -->
            <!--
            <strong v-if="leiter.rolle">
              <translate>
                Projektleiterrolle {{ leiter.rolle }}
              </translate>
            </strong>
            -->

            <!--
              startdatum === null && enddatum === null
              will not be displayed by design
            -->
            <template v-if="leiter.startdatum === null && leiter.enddatum !== null">
              (<translate>Leitung bis</translate> {{ asDate(leiter.enddatum) }})
            </template>
            <template v-else-if="leiter.startdatum !== null && leiter.enddatum === null">
              (<translate>Leitung ab</translate> {{ asDate(leiter.startdatum) }})
            </template>
            <template v-else-if="leiter.startdatum !== null && leiter.enddatum !== null">
              ({{ asDate(leiter.startdatum) }} &ndash; {{ asDate(leiter.enddatum) }})
            </template>
          </li>
        </ul>
    </div>
  </div>
</template>

<script>
import DateTimeHelper from '@/components/mixins/DateTimeHelper'
import EntityValue from '@/components/EntityValue'

export default {
  name: 'fob-projektleiter',
  mixins: [DateTimeHelper],
  components: {
    'fob-entity-value': EntityValue,
  },
  data () {
    return {
      bit: {
        type: 'object',
        render: 'stringRep',
      }
    }
  },
  props: {
    resourceData: {
      type: Array
    },
    isPublic: {
      type: Boolean,
      default: true,
    },
    linkProvider: {
      type: Function,
      default: (data) => {
        const type = data._entityName.split('.').splice(-1)[0].toLowerCase()
        return {
          name: 'anzeigen_einzeln',
          params: {
            resourceType: type,
            resourceId: data._id
          }
        }
      }
    },
  },
}
</script>

<style scoped>
  li {
    margin-bottom: 1.2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Projektleiter.vue